import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ContentType, SeverityEnum, ToastMsg} from 'src/model/page';
import {MessageService} from 'primeng/api';
import {JsonLogin, TudiErrorCode, TudiException} from 'src/model/dto';
import {Router} from '@angular/router';
import {environment} from "../environments/environment";
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  host = environment.host;
  loginInfo: JsonLogin;
  usanaServiceToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjEiLCJ0eXBlIjoiU2VydmljZSJ9.5Tg4FvdoZ1MNXAzn38Iy4ZZxGiLyirmDAGg0BwJoLKQ';
  isBlock = false;

  constructor(
    private http: HttpClient,
    private msgService: MessageService,
    private router: Router
  ) { }

  private parseJSONtoParams(data: any): string {
    const params = new URLSearchParams();
    for (const key in data) {
      if (typeof (data[key]) === 'object') {
        params.append(key, JSON.stringify(data[key]));
      } else {
        params.append(key, data[key]);
      }
    }
    return params.toString();
  }

  post(page: string, op: string, paramTable?: any, token: string = null): Observable<any> {
    const body = this.parseJSONtoParams(paramTable);
    return this.postBody(page, op, body, ContentType.form, token);
  }

  postBody(page: string, op: string, body: string, contentType: ContentType, token: string = null): Observable<any> {
    const url = this.host + '/' + page + '/' + op;
    const headers = new HttpHeaders({
      'Content-Type': contentType,
      Authorization: this.getToken(token)
    });
    const options = { headers };
    return this.http.post(url, body, options).pipe(
      catchError(e => {
        if (e.error && e.error.errorcode) {
          const tudiErr: TudiException = e.error;
          if (tudiErr.errorcode === TudiErrorCode.TudiAuthException) {
            this.router.navigate(['login']);
            this.msgService.add(new ToastMsg(SeverityEnum.error, 'Please login', 'Please login first'));
            return e;
          } else {
            throw e;
          }
        } else {
          this.msgService.add(new ToastMsg(SeverityEnum.error, 'Something went wrong', JSON.stringify(e)));
          throw e;
        }
      })
    );
  }

  getToken(token: string): string {
    if (token) {
      return token;
    } else {
      return this.loginInfo? this.loginInfo.token: '';
    }
  }

  postForm(page: string, op: string, paramTable?: any, token: string = null): Observable<any> {
    let formData = new FormData();
    for (const key in paramTable) {
      formData.append(key, paramTable[key]);
    }
    const url = this.host + '/' + page + '/' + op;
    const headers = new HttpHeaders({
      Authorization: this.getToken(token)
    });
    const options = { headers };
    return this.http.post(url, formData, options);
  }

  get(page: string, op: string, paramTable?: any, token: string = null): Observable<any> {
    const body = this.parseJSONtoParams(paramTable);
    const url = this.host + '/' + page + '/' + op + '?' + body;
    if (op === 'pingTongueAI') {
      console.log('AppService.get: Requesting URL:', url);
    }
    const headers = new HttpHeaders({
      Authorization: this.getToken(token)
    });
    const options = { headers };
    return this.http.get(url, options);
  }

  getWithType<T>(page: string, op: string, paramTable?: any): Observable<T> {
    return this.get(page, op, paramTable);
  }

  generateGetUrl(page: string, op: string, paramTable?: any): string {
    const body = this.parseJSONtoParams(paramTable);
    return this.host + '/' + page + '/' + op + '?' + body;
  }

  login(account: string, password: string): Observable<JsonLogin> {
    const data = {
      account: account,
      password: password
    };
    return this.post('auth', 'memberLogin', data).pipe(
      map((res: JsonLogin) => {
        this.loginInfo = res;
        this.msgService.add(new ToastMsg(SeverityEnum.success, 'Succeed to Login', 'Login as ' + res.account));
        localStorage.setItem('loginInfo', JSON.stringify(this.loginInfo));
        return res;
      })
    );
  }

  setBlock(block: boolean): void {
    this.isBlock = block;
  }

  logout(): void {
    localStorage.removeItem('loginInfo');
    this.loginInfo = null; // Also clear in-memory loginInfo
    this.router.navigate(['login']);
  }
}
